module.exports = __webpack_public_path__ + "img/msteam-addin-01.5fa10c80.png";